import { useContext, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

export default function useBlock() {
  const { api, userID } = useContext(GlobalContext);

  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api]
  );

  /* Fetch Blocked Users */
  const fetchBlockedUsers = async () => {
    try {
      setLoading(true);

      const data = await postRequest(
        "/User/getBlockedWhatsappUser",
        {
          userid: userID,
        }
      );

      if (data?.responseCode === "00") {
        setBlockedUsers(data?.response || []);
      } else {
        setBlockedUsers([]);
      }

      return data;
    } catch (err) {
      console.error(err);
      setBlockedUsers([]);
      toast.error("Error fetching blocked users");
      return null;
    } finally {
      setLoading(false);
    }
  };

  /* Block User */
  const blockUser = async (
    targetUserID,
    mobile,
    name
  ) => {
    try {
      const data = await postRequest(
        "/User/blockWhatsappUser",
        {
          userid: targetUserID,
          mobile,
          name,
        }
      );

      if (data?.responseCode === "00") {
        return true;
      }

      toast.error(
        data?.responseMessage ||
          "Failed to block user"
      );

      return false;
    } catch (err) {
      console.error(err);
      toast.error("Error blocking user");
      return false;
    }
  };

  /* Unblock User */
  const unblockUser = async (
    targetUserID,
    mobile
  ) => {
    try {
      const data = await postRequest(
        "/User/unblockWhatsappUser",
        {
          userid: targetUserID,
          mobile,
        }
      );

      return data?.responseCode === "00";
    } catch (err) {
      console.error(err);
      toast.error("Error unblocking user");
      return false;
    }
  };

  return {
    blockedUsers,
    loading,
    fetchBlockedUsers,
    blockUser,
    unblockUser,
  };
}